import { Component, OnInit } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";
import { Strings } from "../../util/Strings";

@Component({
  selector: "ngx-column-option",
  templateUrl: "./column-option.component.html",
  styleUrls: ["./column-option.component.scss"],
})
export class ColumnOptionComponent implements OnInit {
  columns: any[];
  showColumns: any = [];
  cacheId;

  constructor(
    public dialogRef: NbDialogRef<ColumnOptionComponent>,
  ) { }

  ngOnInit() {
    if (this.columns) this.setColumns(this.columns);
  }

  setColumns(columns:any[], parentName?: string) {

    if (!columns)
      return;

      for (let i = 0; i < columns.length; i++) {
        let column: any = columns[i];
  
        if (column.hasOwnProperty('groupId') && column.hasOwnProperty('children')) {
          this.setColumns(column.children, parentName ? '(' + parentName + ') ' + column.headerName : column.headerName);
        }
        else {
          this.showColumns.push( {headerName: parentName ? '(' + parentName + ') ' + column.headerName : column.headerName, column: column});
        }
      }
  }

  changeVisible(event) {
    event.hide = !event.hide;
  }

  apply(): void {
    if (!this.cacheId || Strings.isBlank(this.cacheId)) {
      this.dialogRef.close(this.columns);
      return;
    }

    this.makeColumnMap(this.columns);

    this.dialogRef.close(this.columns);
  }

  private makeColumnMap(columns): any[] {
    let result: any[] = [];

    Object.keys(columns).forEach((key) => {
      let c: any = columns[key];
      c.hide = c.hide === undefined ? false : c.hide;
      result.push(c);
    });

    return result;
  }
}
